import { gql } from '@apollo/client'
import { query } from '@/service/apollo/client'

const getBrands = () => query(
  gql`
    query {      
      brands {
        id
        brandName
        slug
        brandImage {
          url
          alternativeText
        }
      }
    }
  `
)

const getBrandDetail = (slug) => query(
  gql`
    query {
      brands(where: {slug: "${slug}"}) {
        id
        brandName
        banner {
          url
          alternativeText
        }
        detail
      }
    }
  `
)

const countProductByBrand = (slug) => query(
  gql`
    query {
      watchesCount(where: {brand: "${slug}"})
    }
  `
)

const getProductByBrand = (slug, offset = 0, limit = 10, sort) => {
  let sortQuery = 'createdDate:DESC'
  if (sort === 'a-z') {
    sortQuery = 'model:ASC'
  } else if (sort === 'z-a') {
    sortQuery = 'model:DESC'
  }
  return query(
    gql`  
      query {
        watches (where: {brand: {slug: "${slug}"}}, start: ${offset}, limit: ${limit}, sort: "${sortQuery}") {
          id
          model
          modelNumber
          description
          slug
          brand {
            brandName
            slug
          }
          price
          image {
            url
          }
        }
      }
    `
  )
}

export {
  getBrands,
  getBrandDetail,
  getProductByBrand,
  countProductByBrand
}
